// extracted by mini-css-extract-plugin
export default {"grid":"grid-section-skeleton_grid__Shvzv","square":"grid-section-skeleton_square__cXX0G","shimmer":"grid-section-skeleton_shimmer__-B-n0"};